import { VALIDATE_DESCRIPTION_CODE, VALIDATE_EMAIL_CODE } from "constants/validate"

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const SIP_USER_PATTERN = /^[A-Za-z0-9_.+*-]+$/;
const isStringLengthInRange = (value, min, max) => {
    const normalized = typeof value === "string" ? value : "";
    return normalized.length >= min && normalized.length <= max;
};

const isValidIpv4 = value => {
    const parts = value.split('.');

    return parts.length === 4 && parts.every(part => {
        if (!/^\d+$/.test(part) || (part.length > 1 && part.startsWith('0'))) return false;

        const number = Number(part);

        return number >= 0 && number <= 255;
    });
};

const isValidSipDomain = value => {
    const domain = typeof value === "string" ? value.trim().toLowerCase() : "";

    if (!domain || domain.length > 191 || /\s|:\/\/|[/?#@]/.test(domain)) return false;

    let host = domain;
    const colon = domain.indexOf(':');
    if (colon !== -1) {
        if (colon !== domain.lastIndexOf(':')) return false;

        const port = domain.slice(colon + 1);
        if (!/^\d+$/.test(port) || Number(port) < 1 || Number(port) > 65535) return false;
        host = domain.slice(0, colon);
    }

    if (!host || host.length > 253 || host.endsWith('.') || host.startsWith('.') || host.includes('..')) {
        return false;
    }

    if (/^\d+(?:\.\d+){3}$/.test(host)) return isValidIpv4(host);

    return host.split('.').every(label => label.length >= 1
        && label.length <= 63
        && /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(label));
};

const isValidSipUserPart = value => typeof value === "string"
    && value.length > 0
    && value.length <= 191
    && SIP_USER_PATTERN.test(value);

/**
 * validate email
 * @param {*} email 
 */
export const validateEmail = (email) => {
    if (!email || email.length === 0) return VALIDATE_EMAIL_CODE.REQUIRED
    if (!EMAIL_REGEX.test(email)) return VALIDATE_EMAIL_CODE.INVALID
    const [username = "", domain = ""] = email.split('@')
    if (!isStringLengthInRange(username, 1, 64) || !isStringLengthInRange(domain, 3, 255)) return VALIDATE_EMAIL_CODE.MAX_LENGTH
    return VALIDATE_EMAIL_CODE.VALID
}

export const validateDescription = (description) => {
    if (!isStringLengthInRange(description, 0, 255)) return VALIDATE_DESCRIPTION_CODE.MAX_LENGTH
    return VALIDATE_DESCRIPTION_CODE.VALID
}

export const validateSipUser = value => {
    const normalized = typeof value === "string" ? value.trim() : "";
    const parts = normalized.split('@');
    const sipUser = parts[0]?.trim();

    if (parts.length > 2 || !isValidSipUserPart(sipUser)) return false;
    if (parts.length === 1) return true;

    return isValidSipDomain(parts[1]);
};

/**
 * Validate roomId
 * 10 ký tự số
 * @param {*} roomId 
 * @returns 
 */
export const validateRoomId = (roomId, type) => {
    if (!roomId) return false
    let regex = /^\d{10}$/
    if (type === 'meet') return regex.test(roomId)
    if (type === 'cth') return validateSipUser(roomId)
    return true
}
